import flatten from 'lodash/flatten';
import React, { useContext } from 'react';

import FooterContext from '../service/FooterContext';
import HeaderProvider from '../../Header/service/HeaderProvider';
import MenuMobileAccordion from '../../Header/Mobile/Accordion';
import StaticProvider from '../../Header/service/StaticProvider';
import { DISPLAY_NAME_TOP_NAVIGATION } from '../../../utils/constants';
import { createObjectFromProps } from '../../../utils/object';
import { reduceItems } from '../../Header/service/utils';
import { useRoute } from '../../../utils/sitecoreContext';

const MenuMainHeaderAccordion = ({ variant }) => {
  const route = useRoute();
  const { items } = createObjectFromProps(
    flatten(Object.values(route?.placeholders)).find(
      component => component?.componentName === DISPLAY_NAME_TOP_NAVIGATION,
    ),
  );
  const mappedFields = items?.[0]?.items || [];

  const { primaryItems } = reduceItems(mappedFields, {});
  const { componentName, navigationItems, numberOfFooterColumn } = useContext(FooterContext);

  const renderItems = numberOfFooterColumn
    ? navigationItems?.items?.slice(0, numberOfFooterColumn)
    : navigationItems?.items;

  return (
    <StaticProvider
      appNameConfig={{ variant }}
      componentName={componentName}
      fields={mappedFields}
      primaryItems={primaryItems}
    >
      <HeaderProvider>
        <MenuMobileAccordion items={renderItems} />
      </HeaderProvider>
    </StaticProvider>
  );
};

export default MenuMainHeaderAccordion;
